<script>
    import Chart from 'svelte-frappe-charts';
  
    export let headers;
    export let values;

    let data = {
        labels: headers,
        datasets: [
            {
            values: values
            }
        ]
    };

//     let data = {
//     labels: headers,
//     datasets: [
//       {
//         values: [10, 12, 3, 9, 8, 15, 9, 0, 0, 0, 0, 0]
//       }
//     ]
//   };


    function updateData() {
        data = {
        labels: headers,
        datasets: [
            {
            values: values
            }
        ]
        };
    }

    let chartRef;

</script>
  
<div style="margin: 0%">
    <Chart data={data} type="line"/>
</div>
    